import * as tslib_1 from "tslib";
import { connect } from 'react-redux';
import { initialize } from './actionCreators';
import { getIsInitialized, getTooltipState } from './selectors';
import { getCurrentUser } from '../../publicSession/selectors';
import { flagEnabled } from '../../redux/flags';
var mapStateToProps = function (state, ownProps) {
    var username = ownProps.username;
    var currentUser = getCurrentUser(state);
    return tslib_1.__assign({ isInitialized: getIsInitialized(state, username), isOwner: currentUser && currentUser.username === username }, getTooltipState(state, username), { useV2: flagEnabled(state, 'redesigned_avatar_popup') });
};
var mapDispatchToProps = {
    initialize: initialize,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=UserAvatarTooltip.container.js.map